import AsyncStorage from '@react-native-async-storage/async-storage';

import EventObject from '../models/event_object';
import {refreshToken} from '../../webservice/putrajaya_api';
import { createAction } from "@utils";
import { call, put } from 'redux-saga/effects';

function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

let refreshInProgress = false;
let refreshWaiters = [];

const waitForRefresh = () =>
  new Promise(resolve => refreshWaiters.push(resolve));

const resolveRefreshWaiters = (token) => {
  refreshWaiters.forEach(resolve => resolve(token));
  refreshWaiters = [];
};

// Generic function to handle API calls and token refresh
function* handleApiCall(apiFunction, params) {
    let json = yield call(apiFunction, params);
    let eventObject = new EventObject(json);

    if (eventObject.isTokenExpired()) {
      const newAuthToken = yield call(refreshAuthTokenFlow, params.memberId, params.authToken);

      if (newAuthToken) {
        params.authToken = newAuthToken;
        yield delay(1000);
        json = yield call(apiFunction, params);
        eventObject = new EventObject(json);
      }
    }

    return eventObject;
}

function* refreshAuthTokenFlow(memberId, authToken) {
  if (refreshInProgress) {
    return yield call(waitForRefresh);
  }

  refreshInProgress = true;
  let newToken = null;

  try {
    const json = yield call(refreshToken, {memberId, authToken});
    const refreshEvent = new EventObject(json);

    if (refreshEvent.success === true && refreshEvent.result?.authToken) {
      yield call(saveAuthTokenToStorage, refreshEvent.result);
      yield put(createAction('member/setAuthToken')(refreshEvent.result));
      newToken = refreshEvent.result.authToken;
    }
  } catch (err) {
    //console.log('err', err);
  } finally {
    refreshInProgress = false;
    resolveRefreshWaiters(newToken);
  }

  return newToken;
}

function getUserFromStorage() {
    return AsyncStorage.getItem('@profile', (err, result) => {
      // log('@profile ', result);
      if (err) {
        log('@profile Error: ', err);
      }
  
      return result;
    });
  }

async function saveAuthTokenToStorage(data) {
    let userString = await getUserFromStorage()
    if (userString) {
      let user = JSON.parse(userString)
      if (user) {
        //console.log(user)
        user.authToken = data.authToken;
        AsyncStorage.setItem('@profile', JSON.stringify(user));
      }
    }
  }

export default handleApiCall
